// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__21nrI","search":"Settings_search__349YO","filter":"Settings_filter__3Ifqn"};